module.exports = __webpack_public_path__ + "img/periode_awal.cced3453.svg";